export default httpClient => ({

  get: async ({ tipo_relatorio, estado, idade, genero, oleo, entrevista, patologia, medico, paciente, status, data_inicial, data_final, tipo, token }) => {
    const headers = {
      "Authorization": "Bearer " + token
    }
    const response = await httpClient.post('/relatorio-combinado', { tipo_relatorio, estado, idade, genero, oleo, entrevista, patologia, medico, paciente, status, data_inicial, data_final, tipo }, { headers });
    return { data: response.data }
  },
});